import { Heart, PartyPopper, Music, Flame, Sparkles, Briefcase, ArrowUpRight } from "lucide-react";

const services = [
  {
    icon: Heart,
    title: "Mariage",
    image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1200&q=80",
    bullets: ["Ouverture de bal", "Soirée dansante", "Éclairage romantique", "Ambiance élégante"],
    accent: "Le plus beau jour de votre vie",
  },
  {
    icon: PartyPopper,
    title: "Anniversaire",
    image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=1200&q=80",
    bullets: ["Playlists personnalisées", "Animations", "Ambiance festive", "Tous publics"],
    accent: "Tous âges — toutes ambiances",
  },
  {
    icon: Music,
    title: "Soirées privées",
    image: "https://customer-assets.emergentagent.com/job_anton-pears-dj/artifacts/wu83vu3z_IMG_5703.jpg",
    bullets: ["House", "Généraliste", "Électro", "Années 80 / 90 / 2000"],
    accent: "Du chic au club",
  },
  {
    icon: Flame,
    title: "Plein air & Festivals",
    image: "https://images.unsplash.com/photo-1493676304819-0d7a8d026dcf?auto=format&fit=crop&w=1200&q=80",
    bullets: ["Grosse sonorisation", "Éclairage de scène", "Lasers & structure", "DJ booth pro"],
    accent: "Quand le son devient spectacle",
  },
  {
    icon: Sparkles,
    title: "Nouvel an",
    image: "https://images.unsplash.com/photo-1467810563316-b5476525c0f9?auto=format&fit=crop&w=1200&q=80",
    bullets: ["Compte à rebours", "Ambiance club", "Light show", "Effets premium"],
    accent: "Faites compter chaque seconde",
  },
  {
    icon: Briefcase,
    title: "Entreprises & Afterworks",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
    bullets: ["Ambiance chic", "Musique lounge", "Animations corporate", "Inaugurations"],
    accent: "L'élégance professionnelle",
  },
];

export default function Services() {
  return (
    <section id="prestations" className="relative py-28 lg:py-40 bg-[#070707]" data-testid="services-section">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#3B82F6]/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 reveal">
          <div>
            <div className="text-xs uppercase tracking-[0.4em] text-[#3B82F6]">Prestations</div>
            <h2 className="font-display text-5xl md:text-7xl mt-4 leading-[0.9]">
              Une formule pour<br />chaque moment.
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md leading-relaxed">
            Des packs sur-mesure, du mariage intimiste au festival open-air. Matériel premium inclus, devis sous 24h.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <article
              key={s.title}
              className="reveal group relative rounded-2xl overflow-hidden border border-white/10 bg-[#0a0a0a] hover:border-[#3B82F6]/60 transition-all duration-500"
              style={{ transitionDelay: `${i * 70}ms` }}
              data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
            >
              <div className="relative h-60 overflow-hidden">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/50 to-transparent" />
                <div className="absolute top-4 left-4 glass w-11 h-11 rounded-xl flex items-center justify-center text-[#3B82F6]">
                  <s.icon size={20} />
                </div>
                <div className="absolute bottom-4 left-5">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#3B82F6]">{s.accent}</div>
                  <div className="font-display text-3xl text-white mt-1">{s.title}</div>
                </div>
              </div>

              <div className="p-6">
                <ul className="space-y-2">
                  {s.bullets.map((b) => (
                    <li key={b} className="text-sm text-zinc-300 flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#3B82F6]" /> {b}
                    </li>
                  ))}
                </ul>

                <a
                  href="#contact"
                  className="mt-6 inline-flex items-center justify-between w-full text-sm uppercase tracking-[0.2em] py-3 px-4 rounded-xl border border-white/10 text-zinc-200 hover:border-[#3B82F6] hover:text-[#3B82F6] transition-all group/btn"
                  data-testid={`service-cta-${i}`}
                >
                  Réserver
                  <ArrowUpRight size={18} className="transition-transform group-hover/btn:rotate-45" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
